import React from 'react';
import Plot from 'react-plotly.js';

const ViolinPlotChart = () => {
   // 模拟数据：两组数据
   const trace1 = {
    type: 'violin',
    y: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10],
    name: 'Group 1',
    box: { visible: true },
    line: { color: 'blue' },
    meanline: { visible: true },
    jitter: 0.05,
    side: 'positive', // 修改为纵向显示
  };

  const trace2 = {
    type: 'violin',
    y: [2, 3, 4, 5, 6, 7, 8, 9, 10, 11],
    name: 'Group 2',
    box: { visible: true },
    line: { color: 'red' },
    meanline: { visible: true },
    jitter: 0.05,
    side: 'negative', // 修改为纵向显示
  };

  const data = [trace1, trace2];

  const layout = {
    title: 'Violin Plot Example (Vertical Layout)',
    yaxis: {
      title: 'Value',
    },
    xaxis: {
      title: 'Group',
      tickvals: [1, 2],
      ticktext: ['Group 1', 'Group 2'],
    },
    violingap: 0.1, // 调整小提琴图之间的间隙
  };
  
  return (
    <div style={{ width: '48%', height: '400px' }}>
<Plot data={data} layout={layout} />
    </div>
  );
};

export default ViolinPlotChart;
